'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var tslib_es6 = require('../../tslib.es6-130a177d.js');
var React = require('react');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var React__default = /*#__PURE__*/_interopDefaultLegacy(React);

var StarsIcon = function (props) {
    var computedProps = tslib_es6.__assign({ fill: 'currentColor', width: 20, height: 20 }, props);
    return (React__default['default'].createElement("svg", tslib_es6.__assign({}, computedProps, { viewBox: "0 0 20 20", xmlns: "http://www.w3.org/2000/svg" }),
        React__default['default'].createElement("path", { d: "M8.5 1.94077L9.78666 5.41793L9.86645 5.63355L10.0821 5.71334L13.5592 7L10.0821 8.28666L9.86645 8.36645L9.78666 8.58207L8.5 12.0592L7.21334 8.58207L7.13355 8.36645L6.91793 8.28666L3.44077 7L6.91793 5.71334L7.13355 5.63355L7.21334 5.41793L8.5 1.94077Z" }),
        React__default['default'].createElement("path", { d: "M18.5592 14.5L16.1769 15.3815L15.9613 15.4613L15.8815 15.6769L15 18.0592L14.1185 15.6769L14.0387 15.4613L13.8231 15.3815L11.4408 14.5L13.8231 13.6185L14.0387 13.5387L14.1185 13.3231L15 10.9408L15.8815 13.3231L15.9613 13.5387L16.1769 13.6185L18.5592 14.5Z" }),
        React__default['default'].createElement("path", { d: "M7.04451 16.2573L5.21502 16.9343L4.9994 17.0141L4.91961 17.2297L4.24264 19.0592L3.56567 17.2297L3.48588 17.0141L3.27026 16.9343L1.44077 16.2573L3.27026 15.5804L3.48588 15.5006L3.56567 15.285L4.24264 13.4555L4.91961 15.285L4.9994 15.5006L5.21502 15.5804L7.04451 16.2573Z" })));
};

exports.default = StarsIcon;
//# sourceMappingURL=index.js.map
